import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, makeStyles } from '@material-ui/core';
import type { Procedure } from 'common/types/circulator';

const styles = {
    notesDialog: {
        minWidth: '600px',
    },
};
const useStyles = makeStyles(styles);

interface Props {
    procedure: Procedure;
    enabled: boolean;
    onClose: () => void;
}

export const ProcedureNotesDialog: React.FC<Props> = ({ procedure, enabled, onClose }) => {
    const classes = useStyles();

    return (
        <Dialog open={enabled} onClose={onClose}>
            <DialogTitle>{procedure.title}</DialogTitle>
            <DialogContent className={classes.notesDialog}>{procedure.notes}</DialogContent>
            <DialogActions>
                <Button variant="text" color="primary" onClick={onClose}>
                    Done
                </Button>
            </DialogActions>
        </Dialog>
    );
};
